import { CustomModalContentContainer, DocumentWrapper } from "./itemsToRemove.styled";
import { Icon, Typography } from "@ann/web-components";

const ItemsToRemove = ({ selectedDrives, selectedDocuments }) => {

    const allSelectedItems = [
        ...selectedDrives.map(drive => ({
            title: drive.name,
            icon: 'folder',
            type: 'drive'
        })),
        ...selectedDocuments.map(document => ({
            title: document.name,
            icon: 'description',
            type: 'document'
        }))
    ];
    return (
        <CustomModalContentContainer>
            {allSelectedItems.length > 0 ? (
                allSelectedItems.map((item, index) => (
                    <DocumentWrapper key={`${item.type}-${index}`}>
                        <Icon name={item.icon} />
                        <Typography category="body" size="medium" weight="regular" color="body">
                            {item.title}
                        </Typography>
                    </DocumentWrapper>
                ))
            ) : (
                <Typography category="body" size="medium" weight="regular" color="body">
                    No items selected
                </Typography>
            )}
        </CustomModalContentContainer>
    )
}

export default ItemsToRemove;